import { IFilesOperation, IUpdateFileOperation } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: IFilesOperation = {};

export const loaderSlice = createSlice({
  initialState,
  name: "filesOperations",
  reducers: {
    addFiles: (state, action: PayloadAction<IFilesOperation>) => action.payload,
    updateFileOperation: (state, action: PayloadAction<IUpdateFileOperation>) => {
      return {
        ...state,
        [action.payload.id]: action.payload.file,
      };
    },
    reset: () => initialState,
  },
});

const { actions, reducer } = loaderSlice;

export const { addFiles, updateFileOperation } = actions;

export default reducer;
